import React from "react";

export default function ContactUs() {
  const clickHandler = () => {
    if (typeof window !== "undefined" && window.innerWidth <= 768) {
      const a = document.createElement("a");
      a.href = "tel:+91-7838223507";
      a.click();
    }
  };

  return (
    <div className="contactUsContainer">
      <div className="contactUsContents" onClick={clickHandler}>
        <img
          src="https://media.geeksforgeeks.org/img-practice/dial_phone_icon-1681539298.svg"
          alt="gfg_dialler_icon"
        />
        <span className="sofia-pro">+91-7838223507</span>
      </div>
    </div>
  );
}
